import { EN, TAO_KOE, TaoCookieJar, TaoTrigger } from './../libs';
import NewsletterForm from './newsletter.js';

const PopupElement = function( name, popupEl, data ) {
	this.name = name;
	this.data = data;
	this.popupEl = popupEl;

	this.loaded = false;

	this.setup();
};

/**
 * Basic Setup
 */
PopupElement.prototype.setup = function() {
	const method = this.get_method();

	switch ( method ) {
		case 'load':
			this.show();
			break;

		case 'delay':
			this.popup_delay();
			break;

		case 'exit_intent':
			this.popup_exit_intent();
			break;

		case 'button':
			this.popup_button();
			break;
	}

	if ( 'bottom' === this.data.position || 'right' === this.data.position || 'top' === this.data.position ) {
		this.popupEl.addEventListener( 'click', ( ev ) => {
			if ( ev.target.closest( '.en_hint__close' ) ) {
				this.hide();
			}
		} );
	} else if ( 'popup' === this.data.position ) {

	}

	if ( 'voucher' === this.data.content ) {
		this.register_voucher_form();
	}

	if ( 'newsletter' === this.data.content ) {
		this.register_newsletter_form();
	}
};

PopupElement.prototype.get_method = function() {
	const { method } = this.get_trigger_settings();
	return method || false;
};

PopupElement.prototype.get_trigger_settings = function() {
	return this.data.trigger || {};
};

PopupElement.prototype.get_cookie_settings = function() {
	return this.data.cookie || {};
};

PopupElement.prototype.get_cookie_name = function() {
	const { name } = this.get_cookie_settings();
	return name || this.data.cid;
};

PopupElement.prototype.popup_delay = function() {
	const { delay } = this.get_trigger_settings();
	setTimeout( () => this.show(), delay.time || 0 );
};

PopupElement.prototype.popup_exit_intent = function() {
	const trigger = this.get_trigger_settings();

	const delay = trigger.delay || {};
	const settings = trigger.exit_intent || {};

	TaoTrigger.onExitIntent(
		() => {
			if ( document.querySelector( '.mdl_popup.en_is_active' ) ) {
				document.addEventListener( 'popup_closed.sl', () => this.popup_exit_intent(), { once: true } );
				return;
			}

			const dyPopup = document.querySelector( '.dy-act-overlay' );

			if ( dyPopup ) {
				const callback = ( mutationsList ) => {
					mutationsList.forEach( ( mutation ) => {
						mutation.removedNodes.forEach( ( node ) => {
							if ( node.matches( 'div.dy-modal-container.dy-act-overlay' ) ) {
								this.popup_exit_intent();
								observer.disconnect();
							}
						} );
					} );
				};

				const config = { childList: true };
				const observer = new MutationObserver( callback );
				observer.observe( dyPopup.parentElement, config );

				return;
			}

			this.show();
		},
		{
			exitIntent: true,
			percentUp: settings.percent_up || 10,
			percentDown: settings.percent_down || 50,
			delay: delay.time || 0,
		},
	);
};

PopupElement.prototype.popup_button = function() {
	const hash = '#' + this.name;

	document.addEventListener( 'click', ( ev ) => {
		const linkEl = ev.target.closest( 'a[href="' + hash + '"]' );
		if ( linkEl ) {
			TAO_KOE.console.log( 'CLICK' );
			ev.preventDefault();
			this.show();
		}
	} );
};

/**
 * Display Workflow
 */
PopupElement.prototype.can_show = function() {
	// No valid trigger.
	if ( ! this.get_method() ) {
		return true;
	}

	// Check triggers.
	if ( 'button' === this.get_method() ) {
		return true;
	}

	if ( this.loaded ) {
		TAO_KOE.console.log( 'LOADED' );
		return false;
	}

	// Check Pagedelay.
	if ( this.invalid_pagedelay() ) {
		TAO_KOE.console.log( 'PAGEDELAY' );
		return false;
	}

	// Check cookie.
	if ( this.already_has_cookie() ) {
		TAO_KOE.console.log( 'COOKIE' );
		return false;
	}

	// Check vouchers ( for voucherform ).
	if ( this.has_voucher() ) {
		TAO_KOE.console.log( 'VOUCHER' );
		return false;
	}

	return true;
};

PopupElement.prototype.invalid_pagedelay = function() {
	const trigger = this.get_trigger_settings();
	const delay = trigger.delay || {};
	const current = TaoCookieJar.getPageDelay();

	// If we have a pagedelay and it is smaller than the current pagecount.
	return delay.page && delay.page >= current;
};

PopupElement.prototype.already_has_cookie = function() {
	const settings = this.get_cookie_settings();

	if ( ! settings.enabled ) {
		return false;
	}

	// If the cookie has a valid name.
	if ( ! this.get_cookie_name() ) {
		return false;
	}

	// Get the Cookie.
	const cookie = EN.Cookies.get( this.get_cookie_name() );
	return !! cookie;
};

PopupElement.prototype.has_voucher = function() {
	// Only check this if we have the voucherform.
	if ( 'voucher' !== this.data.content ) {
		return false;
	}

	if ( typeof window.vouchers !== 'undefined' ) {
		// Vouchers are not empty.
		if ( window.vouchers.length > 0 ) {
			return true;
		}
	}

	return false;
};

PopupElement.prototype.show = function() {
	if ( ! this.can_show() ) {
		return;
	}

	this.popupEl.classList.remove( 'en_hidden' );
	if ( 'popup' === this.data.position ) {
		this.trigger_action( 'open' );
	} else if ( 'top' === this.data.position ) {
		document.documentElement.classList.add( 'en_has_hint_top' );
	}

	TAO_KOE.console.log( 'SHOW POPUP: ' + this.name, this.popupEl, this.data );
	this.loaded = true;
};

PopupElement.prototype.hide = function() {
	if ( 'popup' === this.data.position ) {
		// EN_KO Trigger Popup.
		this.trigger_action( 'close' );
	} else if ( 'top' === this.data.position ) {
		document.documentElement.classList.remove( 'en_has_hint_top' );
	}

	this.popupEl.classList.add( 'en_hidden' );
	TAO_KOE.console.log( 'HIDE POPUP: ' + this.name, this.popupEl );

	// Exception for voucher.
	if ( 'voucher' === this.data.content ) {
		return;
	}
	this.set_cookie();
};

PopupElement.prototype.set_cookie = function() {
	const settings = this.get_cookie_settings();
	EN.Cookies.set( this.get_cookie_name(), '1', {
		expires: parseInt( settings.maxage ) || 0,
		path: '/',
		secure: true,
	} );
};

PopupElement.prototype.trigger_action = function( action ) {
	const popupEl = document.getElementById( this.name );

	if ( 'close' === action ) {
		TAO_KOE.close_popup( popupEl );
	} else {
		TAO_KOE.open_popup( popupEl );
	}
};

PopupElement.prototype.register_voucher_form = function() {
	// Initialise Voucher Form.
	const formEls = this.popupEl.querySelectorAll( 'form.tao_voucher_form' );
	formEls.forEach( ( formEl ) => {
		formEl.addEventListener( 'submit', () => this.set_cookie() );
	} );
};

PopupElement.prototype.register_newsletter_form = function() {
	// Initialise Newsletter Form.
	const formEls = this.popupEl.querySelectorAll( 'form.tao_newsletter_form' );
	formEls.forEach( ( formEl ) => {
		NewsletterForm.bind( formEl );
	} );
};

PopupElement.init = function() {
	window.TAO_KOE_ACTIVE_POPUPS = window.TAO_KOE_ACTIVE_POPUPS || {};

	if ( ! window.TAO_KOE_PAGE_POPUPS ) {
		// We only act when we have popups enqueued.
		return;
	}

	const popupEls = Array.from( document.querySelectorAll( '.tao_page_element' ) );
	Object.values( window.TAO_KOE_PAGE_POPUPS || [] ).forEach( ( data ) => {
		const name = data.name;
		const popupEl = popupEls.find( ( pageEl ) => name === pageEl.dataset.name );

		// Only handle the Popup if it was not defined yet.
		if ( popupEl ) {
			window.TAO_KOE_ACTIVE_POPUPS[ name ] ??= new PopupElement( name, popupEl, data );
		}
	} );

	TaoCookieJar.incrementPageDelay();
};

// Init.
TAO_KOE.ready( 'popup.js', PopupElement.init );

// Expose
TAO_KOE.Popup = PopupElement;
export default PopupElement;
